module.exports = __webpack_public_path__ + "static/media/43_B.b9d065db.png";